export const changeSearchValue = (
  prevSearchValue: string, searchValue: string,
) => searchValue;
